import global from './global-variables';
import $ from 'jquery';
window.jQuery = $;
import testData from './fatp-test-data';
import mapConfig from './googlemap-settings';
import utils from '../patterns/utils';
require('jquery-slimscroll');
let nolatlong = false;
/* eslint-disable */
const FindTreatmentProviderResult = {
  _map: null,
  _infowindow: null,
  _viewport: 0,
  _defaults: {
    categories: {
      1: 'Doctor',
      2: 'Nurse Practitioner',
      3: 'Physician Assistant'
    },
    container: '.module-FATP',
    container_map: '#FATP-map',
    container_results: '.module-FATP_ResultsList',
    debug: false,
    loadOrder: ['sectionResultMap', 'sectionResults', 'sectionResultListSort', 'sectionResultList', 'sectionResultControls', 'sectionResultPrintable'],
    fatpPath: '/',
    filters: [{
      'display_name': 'Distance',
      'prop_name': 'Distance'
    },
    {
      'display_name': 'Name',
      'prop_name': 'LastName'
    },
    ],
    // pluginData: is publicly available data passed into the plugin
    pluginData: [],
    pageResults: true,
    numberPerLoad: 10,
    // all properties containing "show" will impact rendering of _getUiSettingsOnly()
    searchType: 'ZipCode',
    showResults: true,
    showResultMap: true,
    showResultList: true,
    showResultListControls: true,
    showResultListSort: true,
    showResultSummary: true,
    showResultPrint: true,
    distance: 50,
    sort: 'Distance',
    zipcode: null,
    state: null,
    latitude: null,
    longitude: null,
    originalLatitude: null,
    originalLongitude: null,
    searchSeed: 0,
    searchTypeRevised: false
  },
  _dataStateOptions: [["AL", "Alabama"], ["AK", "Alaska"], ["AZ", "Arizona"], ["AR", "Arkansas"], ["CA", "California"], ["CO", "Colorado"], ["CT", "Connecticut"], ["DE", "Delaware"], ["DC", "District of Columbia"], ["FL", "Florida"], ["GA", "Georgia"], ["HI", "Hawaii"], ["ID", "Idaho"], ["IL", "Illinois"], ["IN", "Indiana"], ["IA", "Iowa"], ["KS", "Kansas"], ["KY", "Kentucky"], ["LA", "Louisiana"], ["ME", "Maine"], ["MD", "Maryland"], ["MA", "Massachusetts"], ["MI", "Michigan"], ["MN", "Minnesota"], ["MS", "Mississippi"], ["MO", "Missouri"], ["MT", "Montana"], ["NE", "Nebraska"], ["NV", "Nevada"], ["NH", "New Hampshire"], ["NJ", "New Jersey"], ["NM", "New Mexico"], ["NY", "New York"], ["NC", "North Carolina"], ["ND", "North Dakota"], ["OH", "Ohio"], ["OK", "Oklahoma"], ["OR", "Oregon"], ["PA", "Pennsylvania"], ["PR", "Puerto Rico"], ["RI", "Rhode Island"], ["SC", "South Carolina"], ["SD", "South Dakota"], ["TN", "Tennessee"], ["TX", "Texas"], ["UT", "Utah"], ["VT", "Vermont"], ["VA", "Virginia"], ["WA", "Washington"], ["WV", "West Virginia"], ["WI", "Wisconsin"], ["WY", "Wyoming"]],
  _dataOffset: -1,
  _data: [],
  _markerZIndex: 0,
  _xhr: null,
  _searchDelay: null,
  _calculateDistance: function (latitude1, longitude1, latitude2, longitude2) {
    // Formula from https://www.movable-type.co.uk/scripts/latlong.html
    const R = 3958.8, // Earth radius in miles
          lat1Rad = latitude1 * Math.PI/180,
          lat2Rad = latitude2 * Math.PI/180,
          dLatRad = (latitude2 - latitude1) * Math.PI/180,
          dLngRad = (longitude2 - longitude1) * Math.PI/180,
          a = Math.sin(dLatRad/2) * Math.sin(dLatRad/2) + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLngRad/2) * Math.sin(dLngRad/2),
          c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c; // in miles
  },
  _getData: function (opts, callback) {
    var lib = this;

    if (window.location.href.indexOf('ed=1') > -1) {
      setTimeout(function () {
        callback(testData);
      }, 500);
    } else if (lib._defaults.data !== null) {
      setTimeout(function () {
        callback(lib._defaults.data);
      }, 500);
    }
  },
  _getFilterPropertyNameByUrlKey: function (key) {
    // TAKES [_defaults.filters] AND RETURNS CORRECT PROPERTY NAME IN OBJECT

    if (typeof (key) === 'undefined' || key === null) {
      return 'Distance';
    } else {
      var arr = this._defaults.filters.filter(function (item) {
        return item.prop_name.toLowerCase() === key.toLowerCase();
      });

      // Default to Distance if no item
      return (arr.length === 0) ? 'Distance' : arr[0].prop_name;
    }
  },
  _getUrlParamsByKey: function (key) { // Return URL query as arrays split by arrays of [key, value]
    if (typeof key === 'undefined') {
      return null;
    }
    var arr = this._getUrlParams().filter(function (item) {
      return (item[0] === key && typeof (item[1]) !== 'undefined');
    });
    return (arr.length !== 0) ? arr[0][1] : null;
  },
  _getUrlParams: function () { // Return URL query as arrays split by arrays of [key, value]
    return (window.location.search === '') ? [] :
      window.location.search.substring(1).split('&').map(function (query) {
        return [query.split('=')[0], query.split('=')[1]];
      });
  },
  _getUiSettingsOnly: function (opts) { //Returns obj if key contains "show"
    var obj = {}

    for (var prop in opts) {
      if (opts.hasOwnProperty(prop) && prop.indexOf('show') > -1) {
        obj[prop] = opts[prop];
      }
    }

    return obj;
  },
  _runFunctionWhen: function (execCondFunc, execFunc, attempts, name) {
    var lib = this;
    var attempts = attempts || 0;
    var name = name || "no name given";

    if (execCondFunc()) {
      execFunc();
      return true;
    }

    if (attempts > 200) {
      console.error('MAX ATTEMPTS REACHED.  Failed to run function.');
      return false;
    }

    console.debug('Failed to run function:', name, ' on attempt ', attempts, '.  Retry in 250ms');

    setTimeout(function (e) {
      lib._runFunctionWhen(execCondFunc, execFunc, attempts + 1, name);
    }, 250);
  },
  _ss: function() {
    var url = window.location.search;

    if(url.indexOf('ed=1') > -1) {

      if(url.indexOf('error=revised') > -1) {
        this._defaults.searchTypeRevised = true;
      }

    }
  },
  _setInitialState: function (options) {
    // EXTENDING INITIAL PARAMS AND CHECKING THE DEFAULT VALUES

    // CHECK ZIP (if exists) BASED ON URL PARAMS AND VALIDATE
    options.zipcode = this._validateZIPCode(this._getUrlParamsByKey('zipcode')) ? this._getUrlParamsByKey('zipcode') : null;

    // CHECK SORT (if exists) BASED ON URL PARAMS AND VALIDATE
    options.sort = this._getFilterPropertyNameByUrlKey(this._getUrlParamsByKey('sort'));

    // CHECK US STATE (if exists) BASED ON URL PARAMS AND VALIDATE
    options.state = this._validateState(this._getUrlParamsByKey('state')) ? this._getUrlParamsByKey('state') : null;

    // CHECK COORD (if exists) BASED ON URL PARAMS AND VALIDATE
    options.latitude = this._validateCoord(this._getUrlParamsByKey('lat')) ? this._getUrlParamsByKey('lat') : null;
    options.longitude = this._validateCoord(this._getUrlParamsByKey('lng')) ? this._getUrlParamsByKey('lng') : null;

    // CHECK IF STANDALONE MODULE
    options.isStandAlone = $('.module-FATP_Standalone').length > 0 && $('.module-FATP').length === 1;

    // CHECK AGAINST BACKEND SEARCH DATA (if exist)
    if ((typeof (options.pluginData) !== 'undefined')) {
      options.distance = (typeof (options.pluginData.SearchDistance) !== 'undefined') ? options.pluginData.SearchDistance : this._getUrlParamsByKey('distance');
      options.searchType = (typeof (options.pluginData.SearchType) !== 'undefined') ? options.pluginData.SearchType : 'ZipCode';
      options.data = (typeof (options.pluginData.results) !== 'undefined') ? options.pluginData.results : [];
      options.state = options.pluginData.SearchType === 'State' ? (this._validateState(options.pluginData.SearchItem) ? options.pluginData.SearchItem : null) : null;
      options.originalLatitude = options.pluginData.originalLatitude;
      options.originalLongitude = options.pluginData.originalLongitude;
      options.searchSeed = options.pluginData.searchSeed;
      options.searchTypeRevised = options.pluginData.returnCode == "MODIFIED_STATE" ? true : false;
    }

    return options;
  },
  _validateCoord: function (value) {
    return /^-?\d+(\.\d+)?$/.test(value);
  },
  _validateState: function (value) {
    var arr = this._dataStateOptions.filter(function (item) {
      return item.indexOf(value) > -1;
    });
    return (arr.length === 1);
  },
  _validateZIPCode: function (value) {
    return /^\d{5}(-\d{4})?$/.test(value);
  },
  init: function (options) {
    // EXTEND INITIAL PARAMS
    options = this._setInitialState(options);

    //UPDATE OPTIONS FOR REFERENCE (GLOBAL STATE)
    const opts = $.extend({}, this._defaults, options);
    this._defaults = opts;

    this.loadInterface(opts);
    this.bindEvents();
  },
  bindEvents: function () {
    var lib = this;
    var ww = $(window).width();

    //BIND PREVIOUS & NEXT
    $('body').on('click', '.module-FATP_ControlsPrev', function (e) {
      e.preventDefault();
      var visibleData = lib.getVisibleData();
      var offset = parseInt($(lib._defaults.container).attr('data-offset')) - 1;
      var maxLoad = Math.floor((visibleData.length - 1) / lib._defaults.numberPerLoad);

      if (offset > -1 && offset <= maxLoad) {
        var paged = lib.getDataSubset(visibleData, offset);
        lib.loadResults(lib._defaults, paged);

        //Focus on first result
        setTimeout(function() {
          if ( window.innerWidth > 768 ){
            $('.module-FATP_ResultsList').slimScroll({ scrollTo: '0px', alwaysVisible: true });
          }
          document.querySelector('.module-FATP_ResultsList a').focus();
        }, 250);

        $(lib._defaults.container).attr('data-offset', offset);
        $('.module-FATP_ControlsPrev, .module-FATP_ControlsNext').removeAttr('disabled');
        $('.module-FATP_ControlsPrev, .module-FATP_ControlsNext').attr('aria-disabled', 'false');
      }
      if (offset <= 0) {
        $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
        $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
      }
      if (offset >= maxLoad) {
        $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
        $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
      }
    });

    $('body').on('click', '.module-FATP_ControlsNext', function (e) {
      e.preventDefault();
      var visibleData = lib.getVisibleData();
      var offset = parseInt($(lib._defaults.container).attr('data-offset')) + 1;
      var maxLoad = Math.floor((visibleData.length - 1) / lib._defaults.numberPerLoad);

      if (offset > -1 && offset <= maxLoad) {
        var paged = lib.getDataSubset(visibleData, offset);
        lib.loadResults(lib._defaults, paged);

        //Focus on first result
        setTimeout(function() {
          if ( window.innerWidth > 768 ){
            $('.module-FATP_ResultsList').slimScroll({ scrollTo: '0px', alwaysVisible: true });
          }
          document.querySelector('.module-FATP_ResultsList a').focus();
        }, 250);

        $(lib._defaults.container).attr('data-offset', offset);
        $('.module-FATP_ControlsPrev, .module-FATP_ControlsNext').removeAttr('disabled');
        $('.module-FATP_ControlsPrev, .module-FATP_ControlsNext').attr('aria-disabled', 'false');
      }
      if (offset <= 0) {
        $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
        $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
      }
      if (offset >= maxLoad) {
        $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
        $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
      }
    });

    // BIND SORTING
    $('body').on('click', '.module-FATP_ResultsListSort .filter-item', function (e) {
      e.preventDefault();
      var $p = $(this).parents('.module-FATP_ResultsListSort');
      var allSortOpt = document.querySelectorAll('.filter-item a');
      var sortOpt = $(this).children('a')[0];
      var sortby = lib._getFilterPropertyNameByUrlKey($(this).find('a').attr('data-category'));
      var offset = 0; //initial call

      var data = lib.sortJSON(lib._data, sortby);

      //Store data set for future queries
      lib._data = data;
      lib._dataOffset = offset;
      lib._defaults.sort = sortby;

      //Get data subset, based of pager options
      var visibleData = lib.getVisibleData();
      var paged = lib.getDataSubset(visibleData, lib._dataOffset);
      $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
      $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
      if (visibleData.length <= lib._defaults.numberPerLoad) {
        $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
        $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
      } else {
        $('.module-FATP_ControlsNext').removeAttr('disabled');
        $('.module-FATP_ControlsNext').attr('aria-disabled', 'false');
      }

      // Render data
      lib.loadResults(lib._defaults, paged);
      lib.loadPrintResults(lib._defaults, visibleData);

      //SET ARIA-CURRENT
      allSortOpt.forEach(function(opt) {
        opt.setAttribute('aria-current', 'false');
      })
      sortOpt.setAttribute('aria-current', 'true');

      //SET ACTIVE STATE
      $p.find('.filter-item').removeClass('active');
      $(this).addClass('active');
      var ww = $(window).width();
      if (ww > 768) {
        $('.module-FATP_ResultsList').slimScroll({ scrollTo: '0px', alwaysVisible: true });
      }
    });

    $('body').on('click', '.btn-fatp-print', function (e) {
      e.preventDefault();
      window.print();
    });

    // SET UP SCROLLBAR
    if (ww > 768 && $('.module-FATP_ResultsList').length > 0) {
      // If slimscroll is loaded, executes funciton.  Otherwise, checks at regular intervals if slimscroll is defined, and runs when it is.
      lib._runFunctionWhen(function () {
        return typeof ($.fn.slimScroll) !== 'undefined'
      }, function () {
        $('.module-FATP_ResultsList').slimScroll({
          height: '460px',
          distance: '0px',
          size: '24px',
          opacity: 1,
          alwaysVisible: true,
          disableFadeOut: true,
          railBorderRadius: '0px',
          railVisible: true,
          railOpacity: 1,
          // scroll: '10px'
          // betterScroll: 0,//15, -- adding any value here means we can't grab the scroll grip down to the bottom of the scroll track. this fix was meant to reduce scroll jitter. confirm removing it doesn't re-introduce the jitter.
          // betterTouchScroll: 0//15
        });
      }, 0, "Slimscroll List");
    }

    // RESET MAP AND UI on SCREEN RESIZE
    $(window).on('load', function () {
      lib._viewport = $(window).width();
        //Add alt="" to google map images
        setTimeout(function() {
          document.querySelectorAll('#FATP-map img:not([alt])').forEach(function(img) {
          img.setAttribute('alt', '');
        });
      }, 500);
    });

    $(window).on('resize', function () {
      if (window.location.href.indexOf('ed=1') > -1) {
        return;
      }

      var ww = $(window).width();
      var br = lib._viewport;

      if (window.location.href.indexOf(lib._defaults.fatpPath) > -1 && ((br < 768 && ww > 768) || (br >= 768 && ww < 768))) {
        window.location.reload();
      }
    });
  },
  getDataSubset: function (data, offset) {
    var lib = this;

    //Assign new offset
    $(lib._defaults.container).attr('data-offset', offset);
    var n = data.slice(lib._defaults.numberPerLoad * offset, (lib._defaults.numberPerLoad * offset) + lib._defaults.numberPerLoad);

    return n;
  },
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  getSearchParams: function () {
    var lib = this;
    const url = window.location.href;
    const distance = lib.getParameterByName('distance', url) || 50;
    const zipCode = lib.getParameterByName('zipcode', url) || null;
    const state = lib.getParameterByName('state', url) || null;
    const latitude = lib.getParameterByName('lat', url) || null;
    const longitude = lib.getParameterByName('lng', url) || null;
    const originalLatitude = lib.getParameterByName('olat', url) || null;
    const originalLongitude = lib.getParameterByName('olng', url) || null;

    const searchParams = {
      "source_name": "sublocade_patient_fatp_search",
      "distance": distance,
      "distanceType": "MILES",
      "zipCode": zipCode,
      "searchSeed": utils.getSearchSeed(),
      "state": state,
      "latitude": latitude,
      "longitude": longitude,
      "originalLatitude": originalLatitude,
      "originalLongitude": originalLongitude,
    }
    
    return searchParams;
  },
  getVisibleData: function () {
    var lib = this;

    var newBounds = lib._map.getBounds();
    var visible = lib._data.filter(function (d) { return newBounds.contains({ lat: d.Lat, lng: d.Lng }); });
    return visible;
  },
  googleMaps_BuildMap: function (data) {
    var lib = this;
    if ($(lib._defaults.container_map).length === 0) {
      return;
    }

    //default
    var gmap_center = new google.maps.LatLng(lib._defaults.latitude || lib._defaults.originalLatitude || 39.8283459, lib._defaults.longitude || lib._defaults.originalLongitude || -98.5794797);
    var gmap_zoom = 14;

    lib._map = new google.maps.Map(document.getElementById(lib._defaults.container_map.substring(1)), {
      center: gmap_center,
      scrollwheel: false,
      zoomControl: true,
      zoom: gmap_zoom,
      panControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: mapConfig
    });


    // marker and set bound
    var bounds = new google.maps.LatLngBounds();
    lib._infowindow = new google.maps.InfoWindow({
      content: '',
      maxWidth: 200
    });

    data.map(function (datapoint, index) {
      var point = new google.maps.LatLng(datapoint.Lat, datapoint.Lng);
      var markerContent = '<div class="gm-style-iw-close"></div>' + '<div class="gm-style-iw-content">' + '' + '</div>';
      var marker = lib.googleMaps_CreateMarker(lib._map, lib._infowindow, datapoint, markerContent, index, lib._dataOffset);
      datapoint._marker = marker;
      // Set initial viewport to the first page
      (index < lib._defaults.numberPerLoad) && bounds.extend(point);

      return datapoint;
    });

    // Adjust bounds for no results
    if (bounds.isEmpty()) {
      bounds.extend({ lat: gmap_center.lat() - 0.3, lng: gmap_center.lng() - 0.3});
      bounds.extend({ lat: gmap_center.lat() + 0.3, lng: gmap_center.lng() + 0.3 });
    }

    // Map bounds for continental USA
    const desktopLatlng = {
      "north": 50.20688621255411, 
      "south": 24.489783803723938,
      "east": -64.535157650946,
      "west": -129.31054520328286
    }

    const mobileLatlng = {
      "north": 50.20688621255411, 
      "south": 24.489783803723938,
      "east": -74.535157650946,
      "west": -119.31054520328286
    }
    

    /* HOT FIX FOR WHEN MAP DOES NOT FULLY LOAD */
    setTimeout(function () {
      google.maps.event.trigger(lib._map, "resize");

      if ( nolatlong === false ){
        if (window.innerWidth >= 768 ) {
          lib._map.fitBounds(desktopLatlng);
        } else {
          lib._map.fitBounds(mobileLatlng);
        }
      } else {
        lib._map.fitBounds(bounds);
      }
      
      // Set initial minimum zoom level
      if (lib._map.getZoom() > 15) {
        lib._map.setZoom(15);
      }

      // Set listener after map has fully loaded
      lib._map.addListener('dragend', () => { lib.updateSearch() });
      lib._map.addListener('zoom_changed', () => { lib.updateSearch() });

    }, 200);
  },
  googleMaps_ClearMarkers: function () {
    var lib = this;
    lib._data.forEach(function (d) {
      d._marker && d._marker.setMap();
      d._marker = undefined;
    });
  },
  googleMaps_CreateMarker: function (map, infowindow, datapoint, markerContent, index, loadOffset) {
    var lib = this;
    var iconCat = '';

    if (datapoint.Category === '2') {
      iconCat = 'icon-cat-np';
    } else if (datapoint.Category === '3') {
      iconCat = 'icon-cat-pa';
    } else {
      iconCat = 'icon-cat-d';
    }

    // CREATE MARKER
    var gmarker = new google.maps.Marker({
      position: new google.maps.LatLng(datapoint.Lat, datapoint.Lng),
      map: map,
      title: 'Display result information',
      zIndex: 0,
      icon: {
        url: '/assets/img/fatp/' + iconCat + '.png',
        size: new google.maps.Size(33, 43),
        anchor: new google.maps.Point(0, 28),
        scaledSize: new google.maps.Size(30, 44),
      },
    });


    gmarker.content = markerContent;
    google.maps.event.addListener(gmarker, 'click', function () {
      infowindow.close();
      lib.googleMaps_OpenInfoWindow(null, datapoint, gmarker, infowindow, map);
    });

    return gmarker;
  },
  googleMaps_OpenInfoWindow: function (i, datapoint, gmarker, infowindow, map) {
    if (i === -1) {
      return false;
    }

    var desc = [];
    if (datapoint.PracticeName != '' && datapoint.PracticeName != null) {
      desc.push(datapoint.PracticeName);
    }
    if (datapoint.Address1 != '' && datapoint.Address1 != null) {
      desc.push(datapoint.Address1);
    }
    if (datapoint.Address2 != '' && datapoint.Address2 != null) {
      desc.push(datapoint.Address2);
    }
    desc.push(datapoint.City + ', ' + datapoint.State + ' ' + datapoint.ZipCode);
    desc = desc.join('<br />');
    var lib = this;
    var contentString =
      '<div>' +
      '<strong>' + datapoint.FirstName + ' ' + datapoint.LastName + '</strong><br>' +
      '<a class="no-style-link" href="tel:' + datapoint.Phone + '">(' + datapoint.NicePhone.slice(0, 3) + ') ' + datapoint.NicePhone.slice(4) + '</a><br />' +
      desc +
      '</div>';


    infowindow.setContent(contentString);
    infowindow.open(map, gmarker);
    gmarker.setZIndex(++lib._markerZIndex);
    map.setCenter(gmarker.getPosition());
  },
  loadPrintResults: function (opts, data) {
    var lib = this;
    var totalresultCount = lib._data.length;
    var searchType = (opts.searchType === 'ZipCode' ? opts.zipcode : opts.pluginData.state);

    var tmpl = data.map(function (item, index, arr) {
      let practiceName = item.PracticeName == null || item.practiceName == '' ? '' : (item.PracticeName + '<br aria-hidden="true">')
      return '<tr><td>' + (index + 1) + '</td><td>' + item.FirstName + ' ' + item.LastName + '</td><td>' + practiceName + item.Address1 + '</td><td>' + item.City + '</td><td>' + item.NicePhone + '</td><td>' + parseFloat(item.Distance).toFixed(2) + ' miles'; + '</td></tr>';
    }).join('');

    $('.module-FATP_Printable').html('<p><strong><span class="text-counter">' + totalresultCount + '</span> <span class="text-desc"> Treatment providers for <span class="text-zipcode">' + searchType + '</span></span></strong></p><table><tr><td></td><td>Name</td><td>Address</td><td>City</td><td>Phone</td><td>Distance</td></tr>' + tmpl + '</table>')
  },
  loadResults: function (opts, data) {
    var lib = this;
    var totalresultCount = lib._data.length;
    if(totalresultCount <= 0){
      totalresultCount = 0;
    }
    var searchType = (opts.latitude && opts.longitude ? 'near me' : (opts.zipcode != null && !opts.searchTypeRevised ? opts.zipcode : opts.pluginData.state));

    //Print all results on the page
    var tmpl = data.map(function (item) {
      return lib.sectionResultListItem(item, opts);
    }).join(' ');
    $(opts.container_results).html(tmpl);

    document.querySelectorAll(".result-item__trigger").forEach(function (resultItem) {
      resultItem.addEventListener('click', function (e) {
        e.preventDefault();
        var datapoint = lib._data.filter(function (d) { return d.LocationId == resultItem.getAttribute('data-locationid'); })
        datapoint.length > 0 && google.maps.event.trigger(datapoint[0]._marker, 'click');

        var ww = $(window).width();
        if (ww < 768) {
          $('html,body').animate({
            scrollTop: $(lib._container).offset().top - $('.global-header__container').innerHeight()
          }, 500);
        }
      });
    });
  },
  loadInterface: function (opts) {
    var lib = this;

    // RENDER THE DEFAULT UI PLACEHOLDERS BASED ON UI LOADORDER
    var loadOrder = lib._defaults.loadOrder;
    var load = loadOrder.map(function (fn) {
      if (typeof lib[fn] === 'function' && fn.indexOf('section') > -1) {
        var tmpl = lib[fn].call(lib, opts);

        // HACK
        if (fn === 'sectionResultListSort' || fn === 'sectionResultList' || fn === 'sectionResultControls') {
          $('.module-FATP_Results').append(tmpl);
        } else {
          $(lib._defaults.container).append(tmpl);
        }
      }
    });

    // RENDER UI VISIBILITY FROM SETTINGS
    var settings = lib._getUiSettingsOnly(opts);

    for (var prop in settings) {
      if (settings.hasOwnProperty(prop) && settings[prop] === true) {
        var dataAttr = 'data-' + prop.substring(4).toLowerCase();
        $(this._defaults.container).attr(dataAttr, this._defaults[prop]);
      }
    }

    // LOAD DATA
    lib._getData(opts, function (res) {

      //Sort data
      var data = lib.sortJSON(res, opts.sort);
      var offset = 0; //initial call

      //Store data set for future queries
      lib._data = data;
      lib._dataOffset = offset;

      // Render data
      lib.googleMaps_BuildMap(lib._data);
      lib._runFunctionWhen(function() {
        return document.querySelector('#FATP-map') !== null && lib._map.getBounds() != null;
      }, function () {
        setTimeout(function () {
          var visibleData = lib.getVisibleData();
          var paged = lib.getDataSubset(visibleData, lib._dataOffset);

          //Get data subset, based of pager options
          $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
          $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
          if (visibleData.length <= opts.numberPerLoad) {
            $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
            $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
          } else {
            $('.module-FATP_ControlsNext').removeAttr('disabled');
            $('.module-FATP_ControlsNext').attr('aria-disabled', 'false');
          }

          lib.loadResults(opts, paged);
          lib.loadPrintResults(opts, visibleData);
        }, 500);
      }, 0, 'Render Result List')
    });

    // SET ACTIVE/VISIBLE STATE FOR THE RESULTS INTERFACE
    $('.module-FATP').attr('data-searchType', opts.searchType.toLowerCase()).addClass('module-FATP_UIresult').removeClass('module-FATP_UIsearch');

    //SET SS
    this._ss();

    if (opts.searchTypeRevised) {
      $('.fatp-result-summary').prepend(`<p class="form-error flex-vertical-center mb-0 pb-10">
      <svg class="svg--icon-warning">
        <use xlink:href="#icon-warning"></use>
      </svg>
      <span><strong>The ZIP code entered cannot be found.</strong></span>
      <i class="tool-tip-visual"></i>
    </p>`);
    }
  },
  sectionResults: function (opts) {
    $('.module-FATP_wrapper').append('<div class="module-FATP_Results content-grid__item"></div>');

    return '';
  },
  sectionResultControls: function (opts) {
    return '<div class="module-FATP_Controls container"><a href="#" class="module-FATP_ControlsPrev" title="Previous" aria-label="Select Previous 10 to view the last 10 SUBLOCADE treatment providers on the list." role="button">Previous 10</a> <a href="#" class="module-FATP_ControlsNext" title="Next" aria-label="Select Next 10 to view the following 10 SUBLOCADE treatment providers on the list." role="button">Next 10</a></div>';
  },
  sectionResultList: function (opts) {
    return '<div class="module-FATP_ResultsList"></div>';
  },
  sectionResultListItem: function (data, opts) {
    var lib = this;
    var title = data.FirstName + ' ' + data.LastName;
    var distance = parseFloat(data.Distance).toFixed(2) + ' miles';
    var phone = data.p
    // var type = 'doctor';

    var desc = [];
    if (data.Address1 != '' && data.Address1 != null) {
      desc.push(data.Address1);
    }
    if (data.Address2 != '' && data.Address2 != null) {
      desc.push(data.Address2);
    }
    desc.push(data.City + ', ' + data.State + ' ' + data.ZipCode);
    if (data.Phone != '') {
      var phone = "(" + data.Phone.slice(0, 3) + ") " + data.NicePhone.slice(4);
    }
    desc = desc.join('<br />');

    var category = '';

    switch (data.Category) {
      case '2':
        category = '2';
        break;
      case '3':
        category = '3';
        break;
      case '1':
      default:
        category = '1';
    }
    var alt = opts.categories[category];

    /* data category 
        cat = 1, doctor
        cat = 2, nurse practitioner
        cat = 3, physician assistant
    */
    return '<div class="result-item clearfix" data-category="' + category + '" data-locationid="' + data.LocationId + '">' +
      '<div class="result-item__wrapper container">' +
      '<div class="result-item__info">' +
      '<div class="result-item__title"><img class="title__category-pin" src="/assets/img/fatp/pin_category-' + category + '.png" alt="' + alt + '" /><button class="result-item__trigger" data-locationid="'+ data.LocationId +'""><strong>' + title + '</strong></button></div>' +
      (data.PracticeName ? '<div class="result-item__practice"><span>' + data.PracticeName + '</span></div>' : '') +
      '<div class="result-item__desc"><span>' + desc + '</span></div>' +
      '</div>' +
      '<div class="result-item__practical">' +
      '<div class="result-item__phone"><strong>Telephone:</strong><br />' + phone + '</div>' +
      '<div class="result-item__distance"><strong>Distance:</strong><br />' + distance + '</div>' +
      '<div class="result-item__directions"><a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + desc.replace("<br />", ", ").replaceAll(" ", "+").replaceAll(",", "%2C") + '">Get Directions <span class="sr-only">to: ' + desc + '</span></a></div>' +
      '</div>' +
      '</div>' +
      '</div>';
  },
  sectionResultListSort: function (opts) {
    var filters = opts.filters.map(function (filter) {
      return '<li class="filter-item ' + ((opts.sort === filter.prop_name) ? 'active' : '') + `"><a aria-label="${ filter.display_name == 'Name' ? "Select Name to sort the list of SUBLOCADE treatment providers by their name." : "sort by"}" ` + filter.display_name + '"' + ((opts.sort === filter.prop_name) ? 'aria-current="true"' : 'aria-current="false"') + 'role="button" href="#" data-category="' + filter.prop_name.toLowerCase() + '">' + filter.display_name + '</a></li>';
    });
    return '<div class="module-FATP_ResultsListSort clearfix container"><ul class=""><li class="filter-heading">Sort by:</li>' + filters.join('') + '</ul></div>';
  },
  sectionResultMap: function (opts) {
    return '<div class="module-FATP_wrapper content-grid"><div class="module-FATP_Legend"><ul class="module-FATP_Legend-list">' +
      '<li class="category-1">' + opts.categories["1"] + '</li>' +
      '<li class="category-2">' + opts.categories["2"] + '</li>' +
      '<li class="category-3">' + opts.categories["3"] + '</li>' +
      '</ul></div>' +
      '<div id="FATP-map" class="module-FATP_Map content-grid__item" role="application" aria-label="Selecting any of the pins on the map will open a pop-up box providing the name and contact information of the SUBLOCADE treatment provider at the geographic location of the pin."></div></div>';
  },
  sectionResultPrintable: function (opts) {
    return '<div class="module-FATP_Printable"></div>';
  },
  sortJSON: function (obj, objProperty) {
    function compare(a, b) {
      var sortProperty = (objProperty == "Distance") ? "DistanceIndex" : objProperty; // Use DistanceIndex to sort distance

      var type = (typeof (a[sortProperty]) === 'string' || typeof (b[sortProperty]) === 'string') ? 'string' : 'number';
      var result;

      if (type === 'string') {
        result = a[sortProperty].localeCompare(b[sortProperty]);
      } else {
        result = (a[sortProperty] != null ? a[sortProperty] : 999999) - (b[sortProperty] != null ? b[sortProperty] : 999999);
      }
      return result;
    }

    return obj.sort(compare);
  },
  updateSearch: function () {
    var lib = this;
    var newCenter = lib._map.getCenter();
    var newBounds = lib._map.getBounds();
    var neBound = newBounds.getNorthEast();
    var swBound = newBounds.getSouthWest();
    var newDistance = lib._calculateDistance(neBound.lat(), neBound.lng(), swBound.lat(), swBound.lng()).toFixed(2);
    var origLat = lib.getParameterByName('olat');
    var origLng = lib.getParameterByName('olng');
    history.replaceState(history.state, null, `${location.pathname}?lat=${newCenter.lat()}&lng=${newCenter.lng()}&distance=${newDistance}` + (origLat ? '&olat=' + origLat : '') + (origLng ? '&olng=' + origLng : ''));

    // Update results list using cached data first
    lib._dataOffset = 0;
    var visibleData = lib.getVisibleData();
    var paged = lib.getDataSubset(visibleData, lib._dataOffset);
    $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
    $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
    if (visibleData.length <= lib._defaults.numberPerLoad) {
      $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
      $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
    } else {
      $('.module-FATP_ControlsNext').removeAttr('disabled');
      $('.module-FATP_ControlsNext').attr('aria-disabled', 'false');
    }

    lib.loadResults(lib._defaults, paged);
    lib.loadPrintResults(lib._defaults, visibleData);

    // Abort previous request if currently running and request new data
    lib._xhr && lib._xhr.abort();
    lib._searchDelay && clearTimeout(lib._searchDelay);
    lib._searchDelay = setTimeout(() => {
      lib._xhr = $.ajax(global.API_ENDPOINT + "/fatp/search", {
        data: JSON.stringify(lib.getSearchParams()),
        contentType: 'application/json',
        dataType: 'json',
        method: 'POST',
        beforeSend: () => {
          document.querySelector('.svg--icon-loading').classList.remove('hidden');
        },
        complete: () => {
          document.querySelector('.svg--icon-loading').classList.add('hidden');
        }
      })
        .done((data) => {
          if (data.success === false) {
            console.error(data);
            if (!window.debug) {
              window.location.href = "/404";
            }
          }
          lib._dataOffset = 0;
          lib._data.forEach(function (d) { d.DistanceIndex = null; });
          data.result.results.forEach(function (result) {
            var datapoint = lib._data.find(function (d) { return d.LocationId == result.LocationId; })
            if (!datapoint) {
              var markerContent = '<div class="gm-style-iw-close"></div>' + '<div class="gm-style-iw-content">' + '' + '</div>';
              result._marker = lib.googleMaps_CreateMarker(lib._map, lib._infowindow, result, markerContent, null, lib._dataOffset);
              lib._data.push(result);
            } else {
              datapoint.DistanceIndex = result.DistanceIndex;
            }
          });
          lib._data = lib.sortJSON(lib._data, lib._defaults.sort);

          var visibleData = lib.getVisibleData();
          var paged = lib.getDataSubset(visibleData, lib._dataOffset);
          $('.module-FATP_ControlsPrev').attr('disabled', 'disabled');
          $('.module-FATP_ControlsPrev').attr('aria-disabled', 'true');
          if (visibleData.length <= lib._defaults.numberPerLoad) {
            $('.module-FATP_ControlsNext').attr('disabled', 'disabled');
            $('.module-FATP_ControlsNext').attr('aria-disabled', 'true');
          } else {
            $('.module-FATP_ControlsNext').removeAttr('disabled');
            $('.module-FATP_ControlsNext').attr('aria-disabled', 'false');
          }

          lib.loadResults(lib._defaults, paged);
          lib.loadPrintResults(lib._defaults, visibleData);
        })
        .fail((e) => {
          if (e.statusText === 'abort') return;
          console.error("Failed getting FATP data, ", e);
          if (!window.debug) {
            window.location.href = "/404";
          }
        });
    }, 750);
  },
}



export default () => {
  const projectRoot = location.origin;
  const postData = FindTreatmentProviderResult.getSearchParams();
  const newPostData = {
    "source_name": "sublocade_patient_fatp_search",
    "distance": 2000,
    "distanceType": "MILES",
    "zipCode": null,
    "searchSeed": utils.getSearchSeed(),
    "state": null,
    "latitude": 39.8283459,
    "longitude": -98.5794797,
    "originalLatitude": null,
    "originalLongitude": null
  };

  
  $.ajax(global.API_ENDPOINT + "/fatp/search", {
    data: JSON.stringify(postData),
    contentType: 'application/json',
    dataType: 'json',
    method: 'POST',
    beforeSend: () => {
      document.querySelector('.svg--icon-loading').classList.remove('hidden');
    },
    complete: () => {
      document.querySelector('.svg--icon-loading').classList.add('hidden');
    }
  }).then(function(data){
    if (data.success === false) {
      console.error(data);
      if (!window.debug) {
        window.location.href = "/404";
      }
    }
    if (!data.result.originalLatitude ) {
      return $.ajax(global.API_ENDPOINT + "/fatp/search",{
        data: JSON.stringify(newPostData),
        contentType: 'application/json',
        dataType: 'json',
        method: 'POST',
        beforeSend: () => {
          document.querySelector('.svg--icon-loading').classList.remove('hidden');
        },
        complete: () => {
          document.querySelector('.svg--icon-loading').classList.add('hidden');
        }
      }).done((data) => {
        if (data.success === false) {
          console.error(data);
          if (!window.debug) {
            window.location.href = "/404";
          }
        }
        history.replaceState(history.state, null, location.pathname + location.search + (location.search.indexOf('&olat=') < 0 && data.result.originalLatitude ? '&olat=' + data.result.originalLatitude : '') + (location.search.indexOf('&olng=') < 0 &&  data.result.originalLongitude ? '&olng=' + data.result.originalLongitude : ''));
        nolatlong = false;
        FindTreatmentProviderResult.init({
          fatpPath: projectRoot + 'provider',
          pluginData: data.result
        });
        window.FindTreatmentProviderResult = FindTreatmentProviderResult;
      })
    } else {

      history.replaceState(history.state, null, location.pathname + location.search + (location.search.indexOf('&olat=') < 0 && data.result.originalLatitude ? '&olat=' + data.result.originalLatitude : '') + (location.search.indexOf('&olng=') < 0 &&  data.result.originalLongitude ? '&olng=' + data.result.originalLongitude : ''));
      nolatlong = true;
      FindTreatmentProviderResult.init({
        fatpPath: projectRoot + 'provider',
        pluginData: data.result
      });
      window.FindTreatmentProviderResult = FindTreatmentProviderResult;
    }
  })
    .done((data) => {
      if (data.success === false) {
        console.error(data);
        if (!window.debug) {
          window.location.href = "/404";
        }
      } 
    })
    .fail((e) => {
      if (e.statusText === 'abort') return;
      console.error("Failed getting FATP data, ", e);
      if (!window.debug) {
        window.location.href = "/404";
      }
    });

  return FindTreatmentProviderResult;

};
